import React from 'react';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import { Components, Model } from '@singularsystems/neo-core';
import DateCycle from '../../../Models/Dividends/DateCycle';
import { AppService, DomainTypes } from '../../../DomainTypes';
import { DateCycleType } from '../../../Models/Dividends/DateCycleType';
import { action } from 'mobx';
import DateCycleLookup from '../../../Models/Dividends/Lookups/DateCycleLookup';
import TextValues from '../../../Services/TextValues';

export interface IDateCycleEditVM {
    editDateCycle(dateCycleId: number | null, dateCycle: DateCycle | null, filterType: DateCycleType): void;
}

interface IDateCycleDropDownProps {
    viewModel: IDateCycleEditVM;
    id: Model.IPropertyInstance;
    display: Model.IPropertyInstance;
    navigation: Model.IPropertyInstance<DateCycle | null>;
    filterType: DateCycleType;
    onCycleSelected?: (cycle: DateCycleLookup | undefined) => void;
    hidden?: boolean | undefined;
    disabled?: boolean | undefined;
    formClassName?: string | undefined;
    label?: Components.ElementOrText | undefined;
}

@observer
export default class DateCycleDropDown extends React.Component<IDateCycleDropDownProps> {

    private dataCache = AppService.get(DomainTypes.Services.DataCache);

    constructor(props: IDateCycleDropDownProps) {
        super(props);
    }

    private isLoading = true;

    @action
    public async componentDidMount() {
        if (this.dataCache.dateCycles.isExpired) {
            this.isLoading = true;
            await this.dataCache.dateCycles.getDataAsync();
            this.isLoading = false;
        }
    }

    public render() {
        const { viewModel, id, display, navigation, filterType, onCycleSelected, hidden, disabled, formClassName, label } = this.props;

        return (
            <Neo.FormGroupInline className={formClassName} hidden={hidden} label={label}>
                <Neo.AutoCompleteDropDown
                    bind={id}
                    bindDisplay={display}
                    items={this.dataCache.dateCycles.currentData.filter(c => (filterType & c.dateCycleType!) === filterType)}
                    descriptionMember="description"
                    disabled={disabled}
                    onItemSelected={(item) => { navigation.value = null; if (onCycleSelected) { onCycleSelected(item) } }}
                    isLoading={this.isLoading}
                    append={<Neo.Button icon={id.value !== null ? "edit" : "plus"}
                        tooltip={id.value !== null ? "Edit cycle" : "New cycle"}
                        onClick={() => viewModel.editDateCycle(id.value, navigation.value, filterType)} />}
                />
            </Neo.FormGroupInline>
        );
    }
}